import { FunctionComponent } from 'react';
import { usePriceFormatter } from '@/hooks/usePrice';

type PriceProps = {
  value: number;
  className?: string;
  zeroValue?: string;
};

export const Price: FunctionComponent<PriceProps> = ({ value, zeroValue, className }) => {
  const priceFormatter = usePriceFormatter({ zeroValue });
  return <span className={className}>{priceFormatter(value)}</span>;
};
